/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

export const GetSouscriptionWaiverStagesGranteesQuery = gql`
  query GetSouscriptionWaiverStagesGranteesQuery {
    getSouscriptionWaiverStagesGrantees_souscription_waiver_stages {
      beneficiaries {
 type  
birthDate  
regime  
id  
index  
firstName  
lastName  
}
    }
  }
`;

export default GetSouscriptionWaiverStagesGranteesQuery;
